import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActividadTipoEnum } from 'enums/rutaSesionTipo';

export interface InfoSesionI {
	nombreRuta: string;
	nombreSesion: string;
	nombreDesafio: string;
	numeroSesion: number;
	tipoActividad?: ActividadTipoEnum | null;
	objetivoSesion?: string;
	cursos?: string[];
}

const initialState: InfoSesionI = {
	nombreRuta: '',
	nombreSesion: 'Sesion',
	nombreDesafio: '',
	tipoActividad: null,
	numeroSesion: 0,
	objetivoSesion: '',
	cursos: []
};

const infoSesionStateSlice = createSlice({
	name: 'infoSesionState',
	initialState,
	reducers: {
		setInfoSesionState: (state, action: PayloadAction<InfoSesionI>) => {
			return action.payload;
		}
	}
});

export const { setInfoSesionState } = infoSesionStateSlice.actions;

export default infoSesionStateSlice.reducer;
